import SitecoreTextModel from '@models/SitecoreTextModel';

export default class TextDataModel {
  constructor() {
    this['Discount Text'] = new SitecoreTextModel();

    this['Learn More Label'] = new SitecoreTextModel();

    this['Load More Label'] = new SitecoreTextModel();

    this['Title'] = new SitecoreTextModel();
  }
  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Discount Text')) {
      this['Discount Text'].getData(dataSource['Discount Text']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Learn More Label')) {
      this['Learn More Label'].getData(dataSource['Learn More Label']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Load More Label')) {
      this['Load More Label'].getData(dataSource['Load More Label']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Title')) {
      this['Title'].getData(dataSource['Title']);
    }

    return this;
  }
}
